<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list shaped dense>
        <v-subheader>Main Navigation</v-subheader>
        <v-list-item-group color="primary">
          <SideMenuItem
            v-for="(menu_item, index) in menu_objects"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></SideMenuItem>
        </v-list-item-group>
      </v-list>
      <div class="pa-4">
        <v-btn class="mb-2" block rounded outlined color="success">
          <v-icon left>mdi-plus</v-icon>Register Business
        </v-btn>
        <v-btn
          class="mb-2"
          to="/login"
          v-if="!is_login_view || user == null"
          block
          rounded
          outlined
          color="success"
        >
          <v-icon left>mdi-pencil</v-icon>Login
        </v-btn>
      </div>
    </v-navigation-drawer>

    <v-app-bar app color="white" dense white elevation="2" fixed>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <!-- <v-toolbar-title>{{app_title}}</v-toolbar-title> -->

      <div class="d-flex align-center">
        <v-img
          alt="Botswana Services Logo"
          class="shrink mr-1 mobile-app-bar-logo"
          contain
          src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1599568893/botswana%20services/website%20assets/logo_yyz06i.png"
          transition="scale-transition"
          width="150"
        />
      </div>

      <v-spacer class="mobile-display-none"></v-spacer>

      <template v-for="(menu_item, index) in menu_objects">
        <NavbarMenuItem
          v-if="can_access(menu_item)"
          :key="index"
          :to="menu_item.to"
          :icon="menu_item.icon"
          :label="menu_item.label" 
          :badge_value="badge_value"
        ></NavbarMenuItem>
      </template>

      <v-spacer class="mobile-display-none"></v-spacer>

      <v-btn
        class="ma-1 mobile-app-bar-btn"
        dense
        rounded
        outlined
        color="success"
        @click="on_click_register_btn"
      >
        <v-icon left class="mobile-display-none">mdi-plus</v-icon>Register
        Business
      </v-btn>

      <v-btn
        class="ma-1 mobile-app-bar-btn"
        @click="go_to_signin"
        dense
        rounded
        outlined
        color="success"
        v-if="show_login_button"
      >
        <v-icon left class="mobile-display-none">mdi-key</v-icon>Login
      </v-btn>

      <v-btn
        class="ma-1 mobile-app-bar-btn"
        dense
        rounded
        outlined
        color="red"
        v-if="show_logout_button"
        @click="on_logout"
      >
        <v-icon left class="mobile-display-none red--text">mdi-power</v-icon>Logout
      </v-btn>

      <!-- <v-btn href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank" text>
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn> block 7 sedilega,  julia clinic block 9 -->

      <v-row no-gutters>
        <v-col cols="12" no-gutters>
          <v-progress-linear
            :active="is_loading"
            :indeterminate="is_loading"
            absolute
            fixed
            bottom
            height="5"
            color="primary accent-4"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-main class="main-tag">
      <router-view
        :is_loading="is_loading"
        @on-show-loader="show_loader"
        @on-hide-loader="hide_loader"
        @set-user="on_set_user"
      ></router-view>
    </v-main>

    <v-dialog
      v-model="show_loggin_dialogue"
      
      max-width="600"
      max-height="500"
    >
      <v-card>
        <v-card-title class="headline primary--text">
          <v-icon large class="mr-1" color="success">mdi-info</v-icon>
          To Register Your Business</v-card-title
        >
        <v-divider></v-divider>
        <v-row no-gutters class="ma-0 pa-0">
          <v-col no-gutters class="ma-0 pa-0 text-center pt-4">
            <span class="text-h6">New Member ?</span>
            <div class="text-center d-flex pa-4 pb-0">
              <v-img
                height="200"
                max-width="200"
                src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1603770120/botswana%20services/website%20assets/lady_1_h3tw4d.png"
              >
              </v-img>
            </div>
            <v-btn
              class="ma-1 mobile-app-bar-btn mb-4"
              dense
              rounded
              outlined
              color="success"
              @click="go_to_signup"
            >
              <v-icon left class="mobile-display-none">mdi-plus</v-icon>
              <span>Signup Here</span>
            </v-btn>
          </v-col>
          <v-col cols="2" no-gutters class="ma-0 pa-0 text-center pt-5 pb-5 ">
            <v-divider class="mx-4" vertical></v-divider>
          </v-col>
          <v-col no-gutters class="ma-0 pa-0 text-center pt-4">
            <span class="text-h6">Already a Member?</span>
            <div class="text-center d-flex pa-4 pb-0">
              <v-img
                height="200"
                max-width="200"
                src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1603771015/botswana%20services/website%20assets/lady_2_u6bn7f.png"
              >
              </v-img>
            </div>
            <v-btn
              class="ma-1 mobile-app-bar-btn mb-4"
              dense
              rounded
              outlined
              color="success"
              @click="go_to_signin"
            >
              <v-icon left class="mobile-display-none">mdi-plus</v-icon>
              Login here
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import menu_items from "./lib/menu_items";
import SideMenuItem from "./components/SideMenuItem";
import NavbarMenuItem from "./components/NavbarMenuItem";
import TextField from "./components/TextField";
import ServerClient from "./lib/ServerClient";
import Utils from "./lib/Utils";
export default {
  name: "App",

  components: {
    SideMenuItem,
    NavbarMenuItem,
    TextField,
  },
  data: () => ({
    drawer: false,
    app_title: "",
    is_loading: false,
    menu_objects: menu_items.items,
    user: null,
    is_login_view: false,
    show_loggin_dialogue: false,
    login_form: {
      email: "",
    },
    login_form_rules: {
      email: [],
    },
    badge_value: ""
  }),
  watch: {
    $route(to, from) {
      //console.log("to: ", to, " from: ", from);
      document.title = to.meta.title || "Bostwana Services";
      this.is_login_view = false;
      if (to.name == "Login") {
        this.is_login_view = true;
      }

    },
  },
  methods: {
    show_loader() {
      this.is_loading = true;
    },
    hide_loader() {
      this.is_loading = false;
    },
    can_access(menu_item) {
      var res = Utils.can_access(this.user,menu_item);
      return res;
    },
    on_click_register_btn() {
      //console.log(this.user);
      if (this.user == null) {
        //not yet loggedin
        //display a dialogue for signup or register
        this.show_loggin_dialogue = true;
      } else {
        //nyd
        //take user to the register page
        var is_admin = Utils.is_admin(this.user);
        if(is_admin){
          this.$router.push("/admin/businesses/register");
        }else{
          this.$router.push("/owner/businesses/register");
        }
      }
    },
    go_to_signup() {
      this.show_loggin_dialogue = false;
      if (this.$route.name != "Signup") {
        this.$router.push("/signup");
      }
    },
    go_to_signin() {
      this.show_loggin_dialogue = false;

      if (this.$route.name != "Login") {
        this.$router.push("/login");
      }
    },
    on_logout(){
      ServerClient.Login.logout((res) => {
        this.user = null;
        if (this.$route.name != "Home") {
          this.$router.push("/home");
        }
      });
    },
    on_set_user(user){
      this.user = user;
    },
    update_promotions_badge(){
      ServerClient.Promotions.get_new_count({},(res) => {
        this.badge_value = res;
      }, (errors)  => {
        console.log("errors while loading new promotions count");
      });
    }
  },
  mounted() {
    this.is_login_view = this.$route.name == "Login";
    this.user = ServerClient.Login.get_logged_in_user();
    this.update_promotions_badge();
  },
  computed: {
    show_login_button() {
      var show_this_btn = true;
      //!is_login_view == false && (user == null && !is_login_view)
      if (this.$route.name == "Login") {
        show_this_btn = false;
      }
      if (this.user != null) {
        //the user is logged in so hide this button
        show_this_btn = false;
      }
      return show_this_btn;
    },
    show_logout_button(){
      var show_this_btn = false;
      if (this.$route.name == "Login") {
        show_this_btn = false;
      }
      if (this.user != null) {
        //the user is logged in so hide this button
        show_this_btn = true;
      }
      return show_this_btn;
    }
  },
};
</script>


<style scoped>
.app-bg {
  background-color: #88b844; /*green*/
  background-color: #3f8934; /*dark green*/
}

.main-tag {
  /* background-color: coral; */
}

@media screen and (max-width: 480px) {
  .mobile-app-bar-logo {
    max-width: 92px;
    height: 40px;
  }

  .mobile-app-bar-btn {
    padding: 15px 15px !important;
    height: 20px !important;
    font-size: 12px !important;
    margin: 1px !important;
  }
}
</style>

<style >
.app-bg {
  background-color: #047082 !important;
}
.fit-content {
  width: fit-content !important;
}
.round-0 {
  border-radius: 0px !important;
}
.round-4 {
  border-radius: 4px !important;
}
.round-right-4 {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
.round-right-0 {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.round-left-0 {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.hgt-40 {
  height: 40px !important;
}
.pointer {
  cursor: pointer !important;
}
.bgt-1 {
  background-color: chartreuse !important;
}
.bgt-2 {
  background-color: darkblue !important;
}
.bg-white {
  background-color: white !important;
}
.outlined {
  /* 753988021 */
  border: 1px solid #ccc;
  border-top: none;
  border-bottom: none;
}
.fixed {
  position: fixed;
}
.ml-25p {
  margin-left: 25%;
}
.ml-24_6p {
  margin-left: 24.6%;
}
.ml-16_6p {
  margin-left: 16.09%;
}
.wdth-100p {
  width: 100%;
}
.wdth-50p {
  width: 50%;
}
.wdth-98p {
  width: 98%;
}
.wdth-51p {
  width: 51%;
}
.wdth-8-12p {
  width: 67.7%;
}
.right {
  right: 0px;
}
.top-with-nav-bar {
  top: 90px;
}
.top-no-nav-bar {
  /* top: 50px; */
  margin-top: 0px;
  /* box-shadow: inset 1px 1px solid #CCC; */
  border-top: 1px solid #ccc;
}
.col-has-nav-bar {
  padding-top: 1px !important;
}
.componet-has-nav-bar {
  margin-top: 44px !important;
}
.left-btn-text {
  text-align: left !important;
}
.light-bg {
  background-color: #fdfdfddb !important;
}
.inline {
  display: inline-block !important;
}
.tdn {
  text-decoration: none !important;
}
.vh {
  min-height: 100vh;
}
.logo-bg {
  background-color: #ffffffd1 !important;
}
.logo-bg2 {
  background-color: #ffffffc7 !important;
  border-radius: 10px;
  /* box-shadow: inset 1px 1px 16px 0px #2b7182; */
}
.bg-0 > .v-image__image.v-image__image--cover {
  background-position: 0px 0px !important;
}
.zi-94 {
  z-index: 9999;
}
/* .zi-94 {
  z-index: 9999;
} */
.primish {
  background-color: #12394194 !important;
}
.pad-top-150 {
  padding-top: 150px !important;
}
.marg-top-150 {
  margin-top: 150px !important;
}
.marg-top-90 {
  margin-top: 90px !important;
}

.bg-footer {
  background-color: #047082;
}
.wrapper-bg {
  background-color: rgba(0, 0, 0, 0.5);
}
.particles-bg-js {
  /* background-color: yellow; */
  position: absolute;
  top: 0px;
  width: 100vw;
}
.inner-page-container{
  padding-top: 40px;
}
.table-action-div{
  background-color: #047082;
}
.consent-fact-row{
  background-color: #ff000047;
  padding: 5px;
  font-size: 16px;
  border-bottom: 1px dotted red;
}
@media screen and (max-width: 480px) {
  .v-toolbar__content,
  .v-toolbar__extension {
    padding: 0px !important;
  }

  .mobile-display-none {
    display: none !important;
  }
}
</style>